export const FLAG_GETTING_BUSES_CHASSIS = 'FLAG_GETTING_BUSES_CHASSIS';
export const GET_BUSES_CHASSIS = 'GET_BUSES_CHASSIS';
export const CLEAR_BUSES_CHASSIS = 'CLEAR_BUSES_CHASSIS';
export const FLAG_BUS_CHASSIS_ACTIVITY = 'FLAG_BUS_CHASSIS_ACTIVITY';
export const GET_BUS_CHASSIS = 'GET_BUS_CHASSIS';
export const CLEAR_BUS_CHASSIS = 'CLEAR_BUS_CHASSIS';
